import createCachedSelector from 're-reselect';

import { getStakeSlots } from 'app/lib/betting/getStakeSlots';

export default (
  matchStakesSelector,
  visibleLineStakeIdsSelector,
  matchInnerLineListSelector,
  matchSportId,
) => {
  const innerLineInvisibleStakesSelector = createCachedSelector(
    (state, lineId, matchId) => matchStakesSelector(state, matchId),
    visibleLineStakeIdsSelector,
    (state, lineId, matchId) => (
      matchInnerLineListSelector(state, matchId).find((line) => line.id === lineId) || null
    ),
    /**
       * @param {Immutable.List<StakeEntity>} stakes
       * @param {Immutable.List<number>} visibleStakeIds
       * @param {?InnerLineEntry} line
       */
    (stakes, visibleStakeIds, line) => {
      const invisibleStakeIds = line?.stakeIds.filter((stakeId) => {
        return !visibleStakeIds.includes(stakeId);
      });

      return invisibleStakeIds?.map((stakeId) => stakes?.get(stakeId));
    },
  )((state, lineId, matchId) => `${matchId}.${lineId}`);

  /**
     * Create "stake slots available for a given `matchId`" selector for an instance of `<LineSlot />`.
     *
     * @param {number} lineId
     * @param {number} matchId
     * @return {function(state:object):Immutable.List<SlotEntry>}
     */
  return createCachedSelector(
    (state, lineId) => lineId,
    innerLineInvisibleStakesSelector,
    (state, lineId, matchId) => matchSportId(state, { matchId }),
    /**
       * @param {number} lineId
       * @param {Immutable.List<StakeEntity>} stakes
       * @param {number} sportId
       */
    (lineId, stakes, sportId) => {
      return getStakeSlots({ lineId, stakes, sportId });
    },
  )((state, lineId, matchId) => `${matchId}.${lineId}`);
};
